<template>
    <card class="mb-5">
        <template slot="body">
            <h6 class="heading-small text-muted">Confirmation</h6>
            <div class="row">
                <div class="col-sm-12 pb-4">
                    <p class="font-weight-400 mb-4">
                        I hereby certify that the information contained in this application is true and correct to the best of my knowledge. I understand that any false information written in this application shall be grounds for disapproval of this Application for Accreditation.
                    </p>
                </div>
                <div class="col-sm-12">
                    <form-input label="Please type the full name of applicant as confirmation" placeholder="Fullname" v-model="confirmation_signature"></form-input>
                </div>

                <div class="col-sm-12">
                    <button v-if="!isRequesting" class="btn float-left" @click="back">
                        <i class="fas fa-angle-left mr-2"></i> Back
                    </button>
                    <button v-else class="btn float-left" disabled>
                        <i class="fas fa-angle-left mr-2"></i> Back
                    </button>

                    <button v-if="!isConfirmed" class="btn btn-warning float-right" disabled>
                        <i class="fas fa-save mr-1"></i> Submit
                    </button>
                    <button v-else-if="!isRequesting" class="btn btn-warning float-right" @click="submit">
                        <i class="fas fa-save mr-1"></i> Submit
                    </button>
                    <button v-else class="btn btn-warning float-right" disabled>
                        <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                    </button>
                </div>
            </div>
        </template>
    </card>
</template>
<script>
import mixins from "@utils/mixins";

export default {
    name: "ConfirmationSection",

    computed: {
        isRequesting() {
            return this.$parent.$parent.isRequesting;
        },
        isConfirmed() {
            return this.confirmation_signature != null && this.confirmation_signature != "";
        }
    },

    data: () => ({
        confirmation_signature: null,
    }),

    methods: {
        initialize() {
            this.confirmation_signature = null;
        },

        back() {
            this.$emit("back");
        },

        async submit() {
            if (!(await this.confirm("Are you sure you want to save this data?", "")).value) {
                return;
            }
            this.$emit("submit");
        },
    },

    mixins: [mixins],

    mounted() {
        this.initialize();
    }
}
</script>